const Money = {
	amount: true,
	currency: true
};

export { Money };